import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import React, { useEffect, useMemo } from "react";
export default function usePesLoadingSync(param) {
    var loadingStates = param.loadingStates;
    var setIsLoading = useGlobalLoaderContext().setIsLoading;
    var isGlobalLoading = useMemo(function() {
        return loadingStates.some(Boolean);
    }, [
        loadingStates
    ]);
    useEffect(function() {
        setIsLoading(isGlobalLoading);
    }, [
        isGlobalLoading
    ]);
    return;
}
